import React from 'react';
import { Link } from 'react-router-dom';

/** Shared footer for authenticated app views (policies, gambling support). */
const AppFooter: React.FC = () => (
  <footer className="app-footer">
    <div className="footer-content">
      <div className="footer-brand">
        <img src="/white_wide_logo_noBG.png" alt="GallopAI" className="footer-logo" />
      </div>

      <nav className="footer-nav">
        <Link to="/guide/getting-started">User guide</Link>
        <Link to="/faq">FAQ</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
        <Link to="/refund-policy">Refund Policy</Link>
        <Link to="/contact">Contact</Link>
      </nav>

      <div className="footer-disclaimer">
        <p>
          <strong>IMPORTANT:</strong> Gambling involves risk and you must not gamble with funds you can&apos;t afford to lose. It is not a solution to
          any financial difficulties. Please gamble responsibly and only bet what you can afford. If you or someone you know has a gambling problem,
          please seek help.
        </p>
      </div>

      <div className="footer-support">
        <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="support-logo">
          <img src="/gambling-support/18+.png" alt="18+" />
          <img src="/gambling-support/begambleaware.png" alt="BeGambleAware" />
        </a>
        <a href="https://www.gamstop.co.uk" target="_blank" rel="noopener noreferrer" className="support-logo">
          <img src="/gambling-support/gamstop.png" alt="GAMSTOP" />
        </a>
        <a href="https://www.taketimetothink.co.uk" target="_blank" rel="noopener noreferrer" className="support-logo">
          <img src="/gambling-support/take-time.png" alt="Take Time To Think" />
        </a>
        <a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" className="support-logo">
          <img src="/gambling-support/national-gambling-helpline.png" alt="National Gambling Helpline" />
        </a>
      </div>
    </div>
  </footer>
);

export default AppFooter;
